export default __webpack_public_path__ + "static/footer-dark-d89cf6aa1e7e5028647621db0db12df9.png";